import React from "react";
import PropTypes from "prop-types";

export default function RestlessDisplayProperty({
  label = null,
  content,
  ...rest
}) {
  return (
    <div {...rest}>
      <h6 className="text-muted">{label}</h6>
      <span>{content}</span>
    </div>
  );
}

RestlessDisplayProperty.propTypes = {
  label: PropTypes.string,
  content: PropTypes.string.isRequired,
};
